import { CSSObjectWithLabel, StylesConfig } from "react-select";
import { CustomStylesProps } from "./types";

export const variants = {
  primary: {
    unfocused: "#D1D1D1",
    color: "#7F7F7F",
    boxShadow: "0 0 0 0.2rem rgba(108, 117, 125, 0.2)",
  },
  secondary: {
    unfocused: "#000000",
    color: "#000000",
    boxShadow: "0 0 0 0.2rem rgba(0, 0, 0, 0.2)",
  },
  tertiary: {
    unfocused: "#FFC8B0",
    color: "#FFAE8A",
    boxShadow: "0 0 0 0.2rem rgba(255, 200, 176, 0.2)",
  },
};

export const getCustomStyles = ({
  minWidth = undefined,
  maxWidth = undefined,
  minHeight = "52px",
  maxHeight = undefined,
  error = false,
  style = {},
  isMulti = false,
  variant = "primary",
}: CustomStylesProps): StylesConfig<any, boolean> => ({
  control: (base, state): CSSObjectWithLabel => ({
    ...base,
    minHeight,
    minWidth,
    maxWidth,
    maxHeight,
    padding: "4px 4px",
    borderRadius: "4px",
    backgroundColor: undefined,
    borderColor: state.isFocused
      ? variants[variant].color
      : error
      ? "rgb(220 38 38 /100)"
      : variants[variant].unfocused,
    ring: state.isFocused ? variants[variant].color : "#000",
    color: state.isFocused ? variants[variant].color : base.color,
    boxShadow: state.isFocused ? variants[variant].boxShadow : "0",
    "&:hover": {
      // borderColor: state.isFocused ? "#000" : "#000",
      // ring: state.isFocused ? "#000" : "#000",
    },

    "*": {
      boxShadow: "none !important",
      borderColor: "#000",
    },
    ...style?.control,
  }),
  option: (base, state) => ({
    ...base,
    color: state.isSelected ? "#FFF" : "#6B7280",
    backgroundColor: state.isSelected ? "#FF8854" : base.color,
    borderBottom: "1px solid rgba(0, 0, 0, 0.125)",
    "&:hover": {
      color: "#6B7280",
      backgroundColor: "#F1F5F9",
    },
    ...style?.option,
  }),

  indicatorSeparator: () => ({ display: "none" }),
  placeholder: (defaultStyles: any) => {
    return {
      ...defaultStyles,
      textAlign: "start",
      fontSize: "14px",
    };
  },
  singleValue: (base, state) => ({
    ...base,
    ...style?.singleValue,
  }),
  multiValue: (base, state) => {
    return {
      ...base,
      backgroundColor: "white",
      borderRadius: 6,
      border: "1px solid #D7D3D0",
    };
  },
  multiValueRemove: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    color: "#D7D3D0",
    "&:hover": {
      color: "#000000",
      cursor: "pointer",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: 99999999,
    minWidth,
    maxWidth,
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 99999999,
  }),
});
